export default __webpack_public_path__ + "static/media/LeftNumeric.5c9c8c51.jpeg";